import { gql } from '@apollo/client';

export const CONSUMPTION_PERIOD_CLOSE = gql`
    mutation ConsumptionPeriodClose($periodId: ID!) {
        consumptionPeriodClose(periodId: $periodId) {
            period {
                id
                status
                closedAt
            }
        }
    }
`;

export const CONSUMPTION_PERIOD_GENERATE_INVOICE = gql`
    mutation ConsumptionPeriodGenerateInvoice($periodId: ID!) {
        consumptionPeriodGenerateInvoice(periodId: $periodId) {
            period {
                id
                status
                invoicedAt
                invoice {
                    id
                    invoiceId
                    status
                    amount
                }
            }
            invoice {
                id
                invoiceId
                status
                amount
                document {
                    url
                }
            }
        }
    }
`;

export const EXPORT_BALANCES_AS_OF = gql`
    mutation exportBalancesAsOf($asOf: Date!, $until: Date) {
        exportBalancesAsOf(asOf: $asOf, until: $until) {
            content
            filename
            count
        }
    }
`;
